/**
 * Helpers for reading OneTrust consent state.
 *
 * window.OnetrustActiveGroups is a comma-separated string of group IDs the
 * user has granted consent for (e.g. "C0001,C0002,C0004"). It is undefined
 * until OneTrust has resolved consent. The Window type is declared in
 * @types/oneTrust.d.ts.
 */

export const CONSENT_GROUP = {
  STRICTLY_NECESSARY: 'C0001',
  PERFORMANCE: 'C0002',
  FUNCTIONAL: 'C0003',
  TARGETING: 'C0004',
  SOCIAL: 'C0005',
} as const;

export type ConsentGroupId = (typeof CONSENT_GROUP)[keyof typeof CONSENT_GROUP];

/**
 * True if OneTrust has resolved consent and the user has granted the given group.
 * Returns false while OneTrust is still loading.
 */
export function hasConsentGroup(groupId: ConsentGroupId): boolean {
  const groups = window.OnetrustActiveGroups;
  return typeof groups === 'string' && groups.split(',').includes(groupId);
}
